export class Intercom {

  scriptLoaded = false;
  // LFX Dev app id
  intercomAppId: string = 'no-set';
  // Custom app id for testing
  // intercomAppId: string = 'wja8s7iq';
  private clientName: string = '';

  constructor(config: { clientName: string, intercomAppId: string } = { clientName: '', intercomAppId: '' }) {
    this.clientName = config.clientName || '';
    this.intercomAppId = config.intercomAppId || '';
    if (this.intercomAppId === 'no-set') {
      throw new Error('Intercom app id is not set');
    }

    if (!this.intercomAppId) {
      throw new Error('Intercom app id is not set');
    }

    this.setupIntercomSettings();
    this.loadIntercomScript();
  }

  showIntercom() {
    (window as any).Intercom('show');
  }

  private setupIntercomSettings(): void {
    const settings: any = {
      api_base: "https://api-iam.intercom.io",
      app_id: this.intercomAppId,
      hide_default_launcher: true,
    };

    // Add client name as custom attribute if provided
    if (this.clientName) {
      settings.last_app_used = this.clientName;
    }

    (window as any).intercomSettings = settings;

    console.log(':: setupIntercomSettings', JSON.stringify(settings, null, 2));
  }


  /**
   * Loads the Intercom script asynchronously
   */
  private loadIntercomScript(): void {
    if (this.scriptLoaded) {
      return;
    }
    this.scriptLoaded = true;
    const intercomAppId = this.intercomAppId;

    (function () {
      const w = window as any;
      const ic = w.Intercom;

      if (typeof ic === 'function') {
        ic('reattach_activator');
        ic('update', w.intercomSettings);
        return;
      }

      // Create Intercom function
      w.Intercom = function () {
        (w.Intercom as any).c(arguments);
      };

      // Set up Intercom properties
      const i = w.Intercom;
      i.q = [];
      i.c = function (args: any) {
        i.q.push(args);
      };

      // Load Intercom script
      const loadScript = function () {
        const d = document;
        const s = d.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.src = `https://widget.intercom.io/widget/${intercomAppId}`;

        const firstScript = d.getElementsByTagName('script')[0];
        if (firstScript.parentNode) {
          firstScript.parentNode.insertBefore(s, firstScript);
        }
      };

      // Determine when to load the script
      if (document.readyState === 'complete') {
        loadScript();
      } else if (w.attachEvent) {
        w.attachEvent('onload', loadScript);
      } else {
        w.addEventListener('load', loadScript, false);
      }
    })();
  }
}
